export const VENUE_LEADS_TABLE = 'Venue Leads';
